import { Put, Post, Delete } from "./common";

export default class ReportTypeService {
  static list = async (token: string, data: any) =>
    await Post({ path: "report-types/list", token, body: data });

  static create = async (token: string, data: any) =>
    await Post({ path: "report-types", token, body: data });

  static update = async (token: string, data: any) =>
    await Post({ path: "report-types/update", token, body: data });

  static updateStatus = async (id: string, token: string, data: any) =>
    await Put({ path: `report-types/${id}`, token, body: data });

  static deleteById = async (id: string, token: string) =>
    await Delete({ path: `report-types/${id}`, token });
}
